export default class SelectPlaceholder {
    constructor(className) {
        this.elementClass = className;
        this.select = Array.from(document.querySelectorAll(`.${className}`));
        this.events();
    }

    events() {
        [...this.select].forEach((item) => {
            item.addEventListener("change", (e) => {
                e.target.classList.add("selected");
            });
        });
    }
}
